import type { TPortalType } from "store/types";

/** Book catalogue, including companies that have not set a publisher type yet. */
export function isBookPublisher(publisherType: TPortalType | null | undefined): boolean {
    return publisherType == null || publisherType === "book";
}
